import React from 'react';
import classNames from 'classnames';
import AccountsIcon from '@lib/assets/icons/extended_accounts.svg?react';
import ActivateIcon from '@lib/assets/icons/extended_check.svg?react';
import AddIcon from '@lib/assets/icons/extended_add.svg?react';
import Cancel from '@lib/assets/icons/cancel.svg?react';
import DeactivateIcon from '@lib/assets/icons/extended_do_not_disturb.svg?react';
import DeleteIcon from '@lib/assets/icons/extended_delete.svg?react';
import HomeIcon from '@lib/assets/icons/extended_home.svg?react';
import PasswordIcon from '@lib/assets/icons/extended_password.svg?react';
import SearchOff from '@lib/assets/icons/search_off.svg?react';
import ThanksIcon from '@lib/assets/icons/extended_thanks.svg?react';
import VideocamIcon from '@lib/assets/icons/extended_videocam.svg?react';
import OfflineIcon from '@lib/assets/icons/extended_offline.svg?react';
import VideocamOffIcon from '@lib/assets/icons/extended_videocam_off.svg?react';
import WarningIcon from '@lib/assets/icons/extended_warning.svg?react';
import styles from './ModalIcon.module.scss';

interface Props {
  icon: string;
  rootClassName?: string;
}

function getIcon(name: string) {
  switch (name) {
    case 'home':
      return <HomeIcon />;
    case 'delete':
      return <DeleteIcon />;
    case 'manage_accounts':
      return <AccountsIcon />;
    case 'change_password':
      return <PasswordIcon />;
    case 'thanks':
      return <ThanksIcon />;
    case 'group_add':
      return <AddIcon />;
    case 'deactivate':
      return <DeactivateIcon />;
    case 'activate':
      return <ActivateIcon />;
    case 'warning':
      return <WarningIcon />;
    case 'search_off':
      return <SearchOff />;
    case 'cancel':
      return <Cancel />;
    case 'videocam':
      return <VideocamIcon />;
    case 'videocam_off':
      return <VideocamOffIcon />;
    case 'offline':
      return <OfflineIcon />;
    default:
      return <div>DEMO</div>;
  }
}

function ModalIcon(props: Props) {
  const { icon, rootClassName } = props;
  return (
    <div className={classNames(styles.root, rootClassName)}>
      <div>{getIcon(icon)}</div>
    </div>
  );
}

export default ModalIcon;
